import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../common-http.service';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { ICashDonationConfig } from '../../models/ICashDonationConfig';
import { environment } from '../../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpErrorResponse } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class CashDonationService {

  private httpService = inject(CommonHttpService);
  private readonly oidcSecurityService = inject(OidcSecurityService);

  cashDonationConfigSignal = signal<ICashDonationConfig | null>(null);
  isLoading = signal(false);


  constructor() { }


  getDonationConfig(auctionId: number): Observable<ICashDonationConfig> {
    const url = `${environment.apiUrl}/v3/auctions/${auctionId}/cash-donation-config`;
    return this.httpService.get<ICashDonationConfig>(url).pipe(
      tap(response => {
        // console.log('thank you response:', response);
        this.cashDonationConfigSignal.set(response)

      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg =
          typeof error.error === 'string' ? error.error : 'Unknown Error';

        return throwError(() => new Error(errorMsg));
      })
    )
  }
}
